const lan = {
  REDIRECT: "Перенаправлення",
  RULE: {
    SERVICE_TYPE: "Будь ласка, виберіть регіон обслуговування",
    COUNTRY: "Будь ласка, виберіть країну або регіон",
    USERNAME: "Ім'я користувача є обов'язковим.",
    EMAIL: "Електронна пошта обов'язкова",
    EMAIL2: "Будь ласка, введіть правильний формат електронної пошти.",
    PRODUCT: "Будь ласка, виберіть ваш пристрій",
    PRODUCTSN: "Будь ласка, введіть серійний номер",
    PRODUCTSN_LEN: "Будь ласка, введіть від 12 до 15 літер або цифри",
    BIRTHDAY: "Внесення дати народження є обов'язковим",
    REQUIRED: "Обов'язково",
  },
  SYS: {
    HEAD: "СИСТЕМА",
    NOSERVICE:
      "Вибачте, ASUS Chat для обраної Вами країни або регіону недоступний.",
    CHECK_FILESIZE:
      "Будь ласка, перевірте розмір зображення та файлу. Обмеження для зображення:",
    RECONNECTED: "Статус з'єднання повернено до нормального",
    UNABLE_SEND: "Не можливо відправити вкладення",
    NO_NETWORK: "Інтернет з'єднання відсутнє",
    NO_NETWORK_INFO:
      "Інтернет з'єднання відсутнє. Будь ласка, перепідключіть пристрій до інтернету та спробуйте ще.",
  },
  IDLE: {
    HEAD: "Ви були не активні певний час. Чи бажаєте Ви продовжити чат?",
    BUTTON: "Далі",
  },
  DISCONNECT: {
    HEAD: "Чат завершено",
    BUTTON: "Завершити",
  },
  LAYOUT: {
    STEP_1: "Оберіть продукт",
    STEP_2: "Правила обслуговування",
    STEP_3: "Логін",
    STEP_4: "Інформація",
    SELECT_SKILL: "  Product",
    PREV_STEP: "Назад",
    NEXT_STEP: "Далі",
    NOTSET: "Не зазначено.",
    AGREEN: "Погоджуюсь",
    NOTAGREEN: "Не погоджуюсь",
    LEAVE: "Вийти з розмови",
    TYPE_HERE: "Введіть тут",
    CHAT_DOWNLOAD:
      "Будь ласка, натисніть тут для збереження копії чату зі Службою підтримки.",
  },
  COUNTRY: {
    SELECT_COUNTRY: "Будь ласка, оберіть країну обслуговування та регіон",
  },
  POLICY: {
    PRIVACY: "Політика захисту конфіденційності",
    SAT_SURVEY: "Угода про надання послуг",
    CONFIRM_COUNTRY: {
      H1: "Шановний клієнте ASUS,",
      P1:
        "Наразі ви знаходитесь на сторінці Служби онлайн підтримки клієнтів ASUS  в Україні, однак ваш поточний регіон відрізняється від регіону що було вами обрано. Відповідно гарантійній політиці ASUS не кожен тип продукту ASUS має Міжнародну гарантію та підтримку ASUS. Якщо регіон сайту, який ви відкрили відрізняється від регіону, де було придбано продукт ASUS, або відрізняється від поточного регіону, це може вплинути на ваші користувацькі права. Ви можете продовжувати використовувати Службу онлайн підтримки клієнтів ASUS  в Україні, або обрати Службу онлайн підтримки клієнтів ASUS для вашого регіону.",
      P2: "",
      P3: "",
      B1: "Перейти на вебсайт ASUS",
      B2: "Вебсайт",
      B3: "Продовжити використання",
    },
    BULLETIN: {
      HEAD: "Сповіщення про важливе повідомлення",
      CONFIRM: "Зрозуміло",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Будь ласка, заповніть контактну інформацію",
    SURVEY_TYPE: "Будь ласка, виберіть тип обслуговування",
    PROBLEM_BRIEF: "Як би ви описали свою проблему?",
    TYPE1: "Загальні запитання",
    TYPE2: "Запит на ремонт",
    TYPE3: "Технічна підтримка",
    TYPE4: "Гарантійний запит",
    TYPE5: "Опитування і зворотній зв'язок",
    EC_TYPE1: "Інформація про продукт та питання щодо продажу",
    EC_TYPE2: "Маркетинговий захід",
    EC_TYPE3: "Доставка та статус замовлення",
    EC_TYPE4: "Служба повернення",
    SIGNUPDATA: "Реєстраційні дані",
    NAME: "Ім'я",
    TEL: "Телефон",
    ORDER_NO: "Order No.",
    BIRTHDAY: "Дата народження",
    LABEL_EMAIL: "Email",
    EMAIL: "Електронна адреса",
    DEVICEINFO: "Інформація про ваш продукт",
    DEVICENAME: "Назва товару",
    MY_DEVICE: "Ваш продукт",
    MY_DEVICE_SELECT: "Оберіть Ваш продукт",
    MY_DEVICE_EMPTY: "У Вас ще немає зареєстрованих пристроїв",
    LABEL_DEVICESN: "Серійний номер",
    DEVICESN: "Серійний номер товару",
    DEVICESN_ERROR: "Серійний номер, який ви ввели, є недійсним..",
    PREPARE: "Створення чату, підготовка до чату",
    START: "Розпочати Чат",
    AGE_LIMIT: "Обмеження віку",
    AGE_LIMIT_DESC:
      "Ви не відповідаєте віковим вимогам, щоб використовувати ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Bиявлено існуючий чат",
      P1:
        "Ви впевнені, що хочете почати нову бесіду? Після відкриття нової розмови, стара розмова закінчиться.",
      B0: "Підтвердити",
      B1: "Відмінити",
    },
  },
  CONNECTTING: {
    P1: "Будь ласка, почекайте хвилину і не закривайте вікно",
    P2: "ASUS Chat з'єднує вас з доступним агентом",
    NOTE: "Підказка",
    BEFORE_LEAVE: "Ви впевнені, що хочете завершити чат з ASUS?",
    B0: "Завершити",
    B1: "Залишайтеся і зачекайте",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Зв'язатися з ASUS через інші канали",
    MAIL: "Напишіть нам",
    TEL: "Зателефонуйте нам",
    CLOSE: "Закрити",
  },
  WAITTING: {
    WATTING_NUM: "Позиція у черзі",
    PEOPLE: "Клієнт",
    NOTE: "Підказка",
    BEFORE_LEAVEL: "Ви впевнені, що хочете вийти з черги?",
    LEAVE_DESC: "Якщо ви хочете вийти з черги, ви можете завершити чат",
    LEAVE: "Завершити чат",
    STAY: "Залишитись у черзі",
  },
  CHATROOM: {
    TYPING: "Агент пише...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Завершити чат",
      TERMINATE: "Завершити чат",
    },
    FOOTER: { CHAT_FINISH: "Чат завершено" },
    FINISH: "Чат завершено. Можливо у вас залишились питання?",
    SAT_SURVEY: {
      SAT: "Задоволений",
      DISSAT: "Незадоволений",
      SAT_CHOOSE: " Який тип Послуг? (Декілька)",
      HEAD: "Ви були задоволені чатом?",
      DESC:
        "Ваші відгуки - це рушійна сила для нашого постійного покращення. Якщо у вас є які-небудь пропозиції щодо надання послуг чи підтримки ASUS , будь ласка, дайте нам знати.",
      OTHER_OPTION: "Інше",
      OTHER_REASON: "Будь ласка, вкажіть іншу причину",
      SEND: "Надіслати",
    },
    CLOSE: {
      TITLE: "Ви впевнені, що хочете завершити чат?",
      P1:
        'Натисніть кнопку "Так", щоб закрити вікно. Якщо ви захочете використати чат знову, вам знадобиться ще один запит для чату".',
      B0: "Так",
      B1: "Завершити чат",
    },
  },
  ERROR: {
    H1: "Чат не існує або вже завершено",
    CLOSE: "Закрити вікно",
  },
  CHAT_END: {
    H1: "Дуже дякуємо, Чат зараз завершено",
    CLOSE: "Закрити вікно",
  },
  CHAT_CLOSE: {
    H1:
      "Ваша з'єднання розірвалося та не відновлене більш ніж 300 секунд, тому ми припинили цю розмову.",
    DESC:
      "Якщо ви використовуєте бездротову мережу або мобільну мережу, спробуйте знайти місцезнаходження з кращим сигналом; або перейдіть до дротового мережевого підключення. Вибачте за незручності",
    CLOSE: "Закрити вікно",
  },
  SURVEY_DONE: {
    H1: "Дякую. Ви завершили опитування",
    P1:
      'Ваш відгук - це рушійна сила для постійного покращення. Дякуємо вам за те, що ви знайшли час для завершення опитування. Якщо вам потрібна додаткова допомога чи підтримка, натисніть кнопку "Почати новий чат". Якщо ваше питання вирішене, будь ласка, натисніть "Закрити вікно", щоб завершити чат',
    AGAIN: "Розпочати новий чат",
    CLOSE: "Закрити вікно",
    YT_H1: "Дізнайтеся корисні поради та технічні секрети за допомогою відео-підтримки ASUS.",
    YT_H2: "Натисніть, аби перейти!",
  },
  AGENT_OFFLINE: {
    H1: "Агент втратив підключення до Інтернету, чат завершено",
    H2:
      "Будь ласка, не закривайте вікно, ми наполегливо працюємо щоб відновити чат",
    DESC:
      'Ви також можете вибрати завершення чат-сессій та перейти до опитування, або натиснути "Почати новий чат", і ми негайно направимо вас до оператора для продовження сесії. Вибачте за незручності ',
    AGAIN: "Розпочати новий чат",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Unable to use camera and microphone",
    H1: "Ready to join?",
    P1:
      "In order for ASUS customer service staff to help you solve the problem more efficiently, you must allow the device to access your camera and microphone to join the video chat room, and please ensure that your mobile network connection is stable and functioning normally",
    P2:
      "After accessing, you can still freely set the lens switch and microphone mute.",
    VIDEO_STATE: "Video status",
    VIDEO_ON: "On",
    VIDEO_OFF: "Off",
    AUDIO_STATE: "Audio status",
    AUDIO_ON: "On",
    AUDIO_OFF: "Off",
    ENTER: "Join",
    HANGUP: {
      H1: "Hangup",
      P1: "Are you sure to hangup the video chat?",
      CONFIRM: "Confirm",
      CANCEL: "Cancel",
    },
    END: {
      H1: "Video Call has ended",
      P1: "Thank you, this video chat is over, you can close this window.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Select Product",
      STEP_2: "Terms of Service",
      STEP_3: "Login",
      STEP_4: "Information",
      SELECT_SKILL: "Select Product",
      WELCOME: "Ласкаво просимо",
      AGREE: "Погоджуюсь",
      START: "Розпочати",
      CANCEL: "Відмінити",
      WAIT: "Зачекайте, будь ласка.",
      INPUT: "Введіть текст",
      TRANSFER_TOAGENT: "Перейти до діалогу з агентом",
      READMORE:
        "Ви також можете переглянути відповідні поширені запитання (FAQ), дякуємо.",
      COLLAPSE: "Приховати",
      INPUT_SN: "Будь ласка, введіть серійний номер ще раз",
      YOU_MAY_ALSO: "Ви також можете попросити:",
      FOR_FURTHER:
        "Для отримання додаткової інформації, будь ласка, звертайтеся до:",
    RECORDING: "Будь ласка, починайте говорити...",
      RECORDING_NOT_SUPPORTED:
        "Ваш веб-браузер не підтримує розпізнавання мовлення",
      RECORDING_NOT_FOUND:
        "Мікрофон не знайдено. Перевірте, чи надано доступ до мікрофону",
},
    IS_COMPONENT_SN: "The input is the component serial number, you should enter the correct machine serial number.",
WARRANTY: {
      SERIES: "Тип продукту",
      MODEL: "Назва продукту",
      SERIALNO: "Серійний номер продукту",
      STATUS: "Статус гарантії",
      DATE: "Дата закінчення гарантії",
    },
    HEAD: {
      LEAVE: "Вийти",
      CREATE_NEW: "Створити нову бесіду",
    },
    ENTRANCE: {
      POLICY: "Політика конфіденційності",
      AGREE: "Натисність 'Погоджуюсь', щоб розпочати бесіду",
    },
    MESSAGE: {
      WAIT: "Будь ласка, зачекайте, ми шукаємо рішення для вас.",
    },
    END: "Conversation Ended",
    END_MSG: "Ми раді Вам допомогти. Розмову завершено.",
    END_SURVEY: "Пройти опитування",
    END_SURVEY_MSG: "Ми раді Вам допомогти. Розмову завершено.",
    BACKHOME: "Повернутися на головну сторінку",
    SURVEY: {
      DESC:
        "Оцініть, будь ласка, свій досвід спілкування з віртуальним помічником ASUS.",
      SAT: "Задоволений",
      DISSAT: "Незадоволений",
      FEEDBACK: "Будь ласка, залиште свій відгук.",
      SEND: "Надіслати",
      BACK: "Відмінити",
    },
    SURVEY_DISLIKE: {
      H1: "Чому ви незадоволені відповіддю?",
      P: "Ваші відгуки допомагають нам покращити якість наших послуг.",
      BUTTON: "Відправити",
    },
    HISTORY: {
      TITLE: "Історія",
      AGO: "{hours} годин тому",
      CONTINUE: "Продовжити спілкування",
      CLOSE: "Чат був закритий.",
      RESTART: "Перезапуск чату з Віртуальним помічником",
      NON_SERVICE: "Неробочий час",
      VIEW_HISTORY: "Натисніть, аби побачити історію чатів.",
    },
  },
};
export default lan;
